import { createSlice } from "@reduxjs/toolkit";
import { fetchclaimCommunity } from "./claimCommunityApi";

const fetchclaimCommunitySlice = createSlice({
  name: "fetchclaimCommunity",
  initialState: {
    data: [],
    loading: false,
    error: null,
    page: 1,
    pageSize: 10,
  },
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchclaimCommunity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchclaimCommunity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchclaimCommunity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPage, setPageSize } = fetchclaimCommunitySlice.actions;
export default fetchclaimCommunitySlice.reducer;
